import { useRef, useState } from 'react';

// Trava envios duplicados: ignora cliques extras enquanto uma submissao esta em andamento.
// Retorna [submitting, run] — use `submitting` para desabilitar o botao e `run` no lugar do handler.
export default function useSubmitLock(handler) {
  const [submitting, setSubmitting] = useState(false);
  const lockRef = useRef(false); // guarda sincrona, bloqueia antes do re-render

  const run = async (...args) => {
    if (lockRef.current) return; // ja esta enviando, ignora o clique extra
    lockRef.current = true;
    setSubmitting(true);
    try {
      return await handler(...args);
    } finally {
      lockRef.current = false;
      setSubmitting(false);
    }
  };

  return [submitting, run];
}
